import React from 'react';

const WaveOverlay = ({ className = "", height = "h-32", color = "fill-white", inverted = false }) => {
  const wavePath = inverted 
    ? "M0,60 C200,80 400,40 600,60 C800,80 1000,40 1200,60 L1200,0 L0,0 Z"
    : "M0,100 C200,80 400,120 600,100 C800,80 1000,120 1200,100 L1200,120 L0,120 Z";

  return (
    <div className={`absolute ${inverted ? 'top-0' : '-bottom-1'} left-0 w-full z-20 ${className}`}>
      <svg 
        className={`w-full ${height} ${color}`}
        viewBox="0 0 1200 120" 
        preserveAspectRatio="none"
        style={{ shapeRendering: 'geometricPrecision' }}
      >
        <path d={wavePath} style={{ vectorEffect: 'non-scaling-stroke' }} />
      </svg>
    </div>
  );
};

export default WaveOverlay; 